export default {
  labels: {
    subject: 'Subject',
    mobileNumber: 'Mobile No.',
    emailId: 'Email Id',
    status: 'Status',
    fromDate: 'Received After',
    toDate: 'Received Before',
    username: 'Username',
    clientName: 'Client Name',
    message: 'Query',
    created_on: 'Received On',
    brandName: 'Brand',
  },
  titles: {
    heading: 'Manage Queries',
    queriesDetail: 'Manage Query',
    addSubject: 'Add Subject',
    editSubject: 'Edit Subject',
    manageSubject: 'Manage Subjects',
  },
  descriptions: {
    addSubject: 'Add new query subject.',
    editSubject: 'Edit Query Subject',
  },
  submitMessages: {
    addSubject: 'A New Subject Added Successfully.',
    editSubject: 'Subject Successfully Edited',
    queriesDetail: 'Query Resolved Successfully.',
  },
  uniqueValidation: {
    addSubject: 'Subject Already Exists.',
  },
  placeholders: {
    selectSubject: 'Select Subject',
    enterMobile: 'Enter Mobile',
    enterEmail: 'Enter Email',
    selectStatus: 'Select Status',
    selectFromDate: 'Select Received After Date',
    selectToDate: 'Select Received Before Date',
    enterSubject: 'Enter New Subject',
  },
};
